import * as tslib_1 from "tslib";
import React from 'react';
import styled from 'styled-components';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import { message } from 'antd';
const Root = styled.div `
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  height: 400px;
  .bf-container {
    display: flex;
    flex-direction: column;
  }
  .bf-controlbar {
    flex: 0 0 auto;
  }
  .bf-content {
    flex: 1 1 0;
    height: 0;
  }
`;
const UPLOAD_URL = 'https://niu.souche.com/upload/aliyun';
const MBraftEditor = (_a, ref) => {
    var { className, style } = _a, props = tslib_1.__rest(_a, ["className", "style"]);
    const myUploadFn = param => {
        const xhr = new XMLHttpRequest();
        const fd = new FormData();
        const successFn = (event) => {
            param.success({
                url: JSON.parse(xhr.responseText).path,
            });
            message.success(`图片上传成功.`);
        };
        const progressFn = (event) => {
            // 上传进度发生变化时调用param.progress
            param.progress((event.loaded / event.total) * 100);
        };
        const errorFn = (event) => {
            // 上传发生错误时调用param.error
            param.error({
                msg: 'unable to upload.',
            });
            message.error(`图片上传失败.`);
        };
        xhr.upload.addEventListener('progress', progressFn, false);
        xhr.addEventListener('load', successFn, false);
        xhr.addEventListener('error', errorFn, false);
        xhr.addEventListener('abort', errorFn, false);
        fd.append('file', param.file);
        xhr.open('POST', UPLOAD_URL, true);
        xhr.send(fd);
    };
    return (<Root className={className} style={style} ref={ref}>
      <BraftEditor {...props} media={{ uploadFn: myUploadFn }}/>
    </Root>);
};
export default React.forwardRef(MBraftEditor);
